<app-guest-header [innerPage]="true"></app-guest-header>

<div class="main-body">
        <router-outlet></router-outlet>
</div>

<app-guest-footer></app-guest-footer>

<!-- <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
        class="bi bi-arrow-up-short"></i></a> -->